// Utility to strip code/pre blocks from markdown and convert to plain text
// This helps prevent layout issues in the chat UI

/**
 * Removes triple-backtick code blocks and indented code blocks from markdown,
 * returning the content as plain text (no code formatting).
 * @param markdown The markdown string to sanitize
 * @returns The sanitized string with code blocks converted to plain text
 */
export function stripCodeBlocks(markdown: string): string {
  // Remove triple-backtick code blocks (```...```)
  let result = markdown.replace(/```[\s\S]*?```/g, (block) => {
    // Remove the backticks, keep the content as plain text
    return block.replace(/```/g, '');
  });
  // Remove indented code blocks (4 spaces or a tab at line start)
  result = result.replace(/^( {4}|\t).*/gm, (line) => line.replace(/^( {4}|\t)/, ''));
  return result;
}

/**
 * Removes leading spaces from each line in a markdown string.
 * This prevents Markdown from rendering lines as code/pre blocks.
 */
export function stripLeadingSpaces(markdown: string): string {
  return markdown
    .split('\n')
    .map(line => line.replace(/^[ \t]+/, '')) // Remove all leading spaces/tabs
    .join('\n');
}

/**
 * Sanitizes markdown by removing code blocks and leading spaces.
 * Use this before rendering markdown in chat.
 */
export function sanitizeMarkdown(markdown: string): string {
  let result = stripCodeBlocks(markdown);
  result = stripLeadingSpaces(result);
  return result;
} 